var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubSingleDiscountCover = function SvgSubSingleDiscountCover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.828,
    height: 18.341,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "subSingleDiscountCover_svg__a",
    x1: 1.076,
    x2: 0.031,
    y1: 0.529,
    y2: 0.507
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EB4742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F39E9B"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#subSingleDiscountCover_svg__a)",
    d: "M1.2 0h39.634c.552 0 .994.459.994 1.011V17.33c0 .553-.43 1.011-.982 1.011h-30.65c-3.823 0-7.113-2.678-7.851-6.429L.23 1.167A.97.97 0 0 1 1.2 0"
  })));
};
export default SvgSubSingleDiscountCover;